import React, { useState, useEffect } from 'react'
import { useNavigate } from "react-router-dom";

import Alert from '@mui/material/Alert';
import { Button, Divider, TextField, Grid, Typography, Box, CircularProgress } from "@mui/material"

import { getStockorderproductStruct, setData } from './StockorderproductStruct'
import { updateTextValue, handleSubmit, updateValue, updateSelectedValue, formFieldToReqJSON } from '../../core/js/FormUtils'
import { createAPI, updateAPI, getAPI, updateEditableAPI } from './StockorderproductAPI';
import { CoreContext } from "../../core/context/CoreContext";

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { validMobileNumberEntry, validNameEntry, validEmailEntry } from '../../core/js/FormValidation';

import { getPathVariable } from '../../core/js/UrlUtils';
import { useSearchParams } from "react-router-dom";
import RadioForBoolean from '../../core/form/RadioForBoolean';
import MyDate from '../../core/components/MyDate';
import { useDispatch, useSelector } from 'react-redux';
import { updateStockorderproductObj, addStockorderproductObj, setShowEditForStockorderproduct, addStockorderObj } from 'store/slice/ManufSlice';
import { setApiInProgress } from 'store/slice/HeaderSlice';
import { setMessage } from 'store/slice/HeaderSlice';
import { addStockOrderProductAPI } from 'api/OmsFactoryopsWebServices';
import RadioForPrintingType from 'components/mfproductorder/components/RadioForPrintingType';
import RadioForStitchingType from 'components/mfproductorder/components/RadioForStitchingType';
import { setProduct2skill2exp2rateList } from 'store/slice/ManufSlice';
import { getProduct2skill2exp2rateInfoByTypeidandworkeridAPI } from 'components/product2skill2exp2rate/Product2skill2exp2rateAPI';
import { setSupplierTypeId } from 'store/slice/AppSlice';
import { use } from 'react';
import FieldView2 from 'core/components/layout/FieldView2';



export default function StockorderproductEditFormImpl() {
    const dispatch = useDispatch();
    const [formValues, setFormValues] = useState(getStockorderproductStruct);
    const [showError, setShowError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('Something went wrong');
    const [dataLoaded, setDataLoaded] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();
    const { stockorderObj } = useSelector((state) => state.manufslice.stockorderDashboard);
    const { supplierId, supplierTypeId } = useSelector((state) => state.appslice);

    const { stockorderproductDashboard } = useSelector((state) => state.manufslice);
    const [stockorderproductId, setStockorderproductId] = useState(stockorderproductDashboard.selectedId);
    const { businessid } = useSelector((state) => state.headerslice.userprofileInfo);
    const { product2skill2exp2rateList } = useSelector((state) => state.manufslice);
    const { mfpartyList } = useSelector((state) => state.manufslice);


    const { mfproductList } = useSelector((state) => state.manufslice);
    const [productListByWorker, setProductListByWorker] = useState([]);
    const handleDynamicSelectedValueForproductid = (e) => {
        updateSelectedValue(formValues, setFormValues, e,
            'productname', e.target.value == 0 ? 'Select Item' : mfproductList.find(obj => obj.id === e.target.value).title);
    }
    const { mfdeliverypriorityList } = useSelector((state) => state.manufslice);
    const handleDynamicSelectedValueFordeliverypriorityid = (e) => {
        updateSelectedValue(formValues, setFormValues, e,
            'deliverypriorityname', e.target.value == 0 ? 'Select Item' : mfdeliverypriorityList.find(obj => obj.id === e.target.value).title);
    }
    const { workerList } = useSelector((state) => state.manufslice);
    const handleDynamicSelectedValueForstitchingworkerid = (e) => {
        updateSelectedValue(formValues, setFormValues, e,
            'stitchingworkername', e.target.value == 0 ? 'Select Item' : workerList.find(obj => obj.id === e.target.value).title);
    }
    useEffect(() => {
        getProduct2skill2exp2rateInfoByTypeidandworkeridAPI(supplierTypeId, supplierId, () => { },
            (data) => {
                dispatch(setProduct2skill2exp2rateList(data));

            }
        )
    }, []);
    useEffect(() => {
        if (supplierTypeId === 0) {
            if (product2skill2exp2rateList && product2skill2exp2rateList.length > 0) {
                let productIdListBySelectedWorker = product2skill2exp2rateList
                    .filter(obj => obj.workerid === supplierId)
                    .map(obj => obj.productid);
                console.log('productIdListBySelectedWorker:', productIdListBySelectedWorker);
                setProductListByWorker(
                    mfproductList.filter(product => productIdListBySelectedWorker.includes(product.id))
                )
            }

        } else {
            setProductListByWorker(mfproductList) ;
        }

    }, [product2skill2exp2rateList]);

    const { apiInProgress } = useSelector((state) => state.headerslice)
    useEffect(() => {
    }, [apiInProgress])

    useEffect(() => {
        const rateObj = product2skill2exp2rateList.find(obj => obj.workerid === supplierId && obj.productid === formValues.productid.value)
        if (rateObj) {
            setFormValues({
                ...formValues,
                ['stitchingrate']: {
                    ...formValues['stitchingrate'],
                    value: rateObj.rate,
                },
            });
        }
    }, [formValues.productid.value]);

    useEffect(() => {
        if (stockorderproductId !== -1) {
            if (dataLoaded) return;
            getAPI(stockorderproductId, loadForm);
        }
        else {
            setFormValues({
                ...formValues,

                ['stockorderid']: {
                    ...formValues['stockorderid'],
                    value: stockorderObj.id,
                },
                ['printingtype']: {
                    ...formValues['printingtype'],
                    value: false
                },
                ['stitchingtype']: {
                    ...formValues['stitchingtype'],
                    value: false
                },
                ['withprinting']: {
                    ...formValues['withprinting'],
                    value: false
                },
                ['stitchingworkerid']: {
                    ...formValues['stitchingworkerid'],
                    value: supplierId,
                },
                ['stitchingworkername']: {
                    ...formValues['stitchingworkername'],
                    value: getWorkerName(),
                },
            })
            setDataLoaded(true);
        }

    }, []);
    const getWorkerName = () => {
        if (supplierTypeId == 0) {
            return workerList.find(obj => obj.id === supplierId).title
        } else if (supplierTypeId == 1) {
            return mfpartyList.find(obj => obj.id === supplierId).title
        }
    }

    const setNotification = (message) => {
        dispatch(setMessage(message));
    }
    const loadForm = (data) => {
        setData(data, formValues, setFormValues);
        setDataLoaded(true);
    }
    const handleRadioChange = (name, value) => {
        setShowError(false);
        console.log(value + " == " + getRadioAPIvalue(value))
        updateValue(formValues, setFormValues, name, getRadioAPIvalue(value));
    }
    const getPrintingTypeRadioValue = (value) => {
        if (value)
            return "Digital"
        else
            return "Screen"
    }
    const getRadioValue = (value) => {
        if (value)
            return "yes"
        else
            return "no"
    }
    const getRadioAPIvalue = (value) => {
        if (value === "yes")
            return true
        else
            return false
    }
    const handleTextChange = (e) => {
        setShowError(false);
        const { name, value } = e.target;
        // Remove newlines for the description field
        const sanitizedValue = value.replace(/[\r\n]+/g, '')
        updateTextValue(formValues, setFormValues, { target: { name, value: sanitizedValue } });
    }
    const handleDoubleChange = (e) => {
        setShowError(false);
        const { name, value } = e.target;

        // Do not allow starting with '.'
        if (value.startsWith('.')) {
            return;
        }

        // Allow empty string so user can delete all characters
        if (value === '' || value === '.') {
            updateTextValue(formValues, setFormValues, { target: { name, value } });
            return;
        }

        // Regex: Allow up to 9 digits before decimal, optional decimal, up to 2 digits after decimal (Indian Rupees format)
        const regex = /^\d{0,9}(\.\d{0,2})?$/;

        if (regex.test(value)) {
            updateTextValue(formValues, setFormValues, { target: { name, value } });
        }
    }
    const handleNameChange = (e) => {
        setShowError(false);

        if (validNameEntry(e))
            updateTextValue(formValues, setFormValues, e);
    }
    const handleMobileChange = (e) => {
        setShowError(false);

        if (validMobileNumberEntry(e))
            updateTextValue(formValues, setFormValues, e);
    }
    const handleEmailidChange = (e) => {
        setShowError(false);

        if (validEmailEntry(e))
            updateTextValue(formValues, setFormValues, e);
    }

    const createSuccessCallback = (obj) => {
        dispatch(setApiInProgress(false));
        if (obj.stockorderInfo !== null && obj.stockorderInfo.id !== undefined) {
            dispatch(addStockorderObj(obj.stockorderInfo));
        }
        dispatch(addStockorderproductObj(obj.stockorderproductInfo));
        setNotification('Record has been cretaed successfully !!!');
        dispatch(setShowEditForStockorderproduct(false));
    }
    const updateSuccessCallback = (obj) => {
        dispatch(setApiInProgress(false));
        dispatch(updateStockorderproductObj(obj));
        setNotification('Record with id[' + stockorderproductId + '] has been updated successfully !!!');
        dispatch(setShowEditForStockorderproduct(false));

    }
    const failuerCallback = (errorMsg) => {
        dispatch(setApiInProgress(false));
        setErrorMsg(errorMsg);
        setShowError(true);
    }
    const callCreateAPI = (formValues, successCallBack, failuerCallback) => {
        dispatch(setApiInProgress(true));
        createAPI(formValues, successCallBack, failuerCallback);
    }
    const callUpdateAPI = (id, formValues, updateSuccessCallback, failuerCallback) => {
        dispatch(setApiInProgress(true));
        updateAPI(id, formValues, updateSuccessCallback, failuerCallback);
    }
    const calladdStockOrderProductAPI = (formValues, successCallBack, failuerCallback) => {
        addStockOrderProductAPI({
            stockOrderInfo: {
                partyid: supplierId,
                partytypeid: supplierTypeId,
            },
            stockOrderProductInfo: {
                productid: formValues.productid.value,
                productname: formValues.productname.value,
                qty: formValues.qty.value,
                matter: formValues.matter.value,
                deliverypriorityid: formValues.deliverypriorityid.value,
                deliverypriorityname: formValues.deliverypriorityname.value,
                expecteddelivery: formValues.expecteddelivery.value,
                printingtype: formValues.printingtype.value,
                stitchingtype: formValues.stitchingtype.value,
                withprinting: formValues.withprinting.value,
                stockorderid: formValues.stockorderid.value,
                stitchingrate: formValues.stitchingrate.value,
                stitchingworkername: formValues.stitchingworkername.value,
                stitchingworkerid: formValues.stitchingworkerid.value,
            }
        },
            successCallBack, failuerCallback,
        )
    }
    const onSubmit = (e) => {
        handleSubmit(e, stockorderproductId, formValues, setFormValues, createSuccessCallback, updateSuccessCallback, failuerCallback, calladdStockOrderProductAPI, callUpdateAPI);
    }
    const setDate = (fieldName, value) => {
        var date = new Date(value);

        const day = date.getDate();
        const dayStr = day < 10 ? '0' + day : day.toString();

        const month = date.getMonth() + 1;
        const monthStr = month < 10 ? '0' + month : month.toString();
        var dateStr = date.getFullYear() + "-" + monthStr + "-" + dayStr + "T00:00:00.000Z";
        updateValue(formValues, setFormValues, fieldName, dateStr);
    }
    return (
        <form noValidate onSubmit={onSubmit} >
            <Grid container direction="column" padding={.25}>
                {showError ? <Alert severity="error">{errorMsg}</Alert> : ''}
                <Box sx={{ flexGrow: 1, }}>
                    <Grid item sx={{ overflowY: "scroll", backgroundColor: 'white', maxHeight: '70vh', mt: 2 }}>
                        <Grid container direction="column" padding={2}>
                            <Grid item>
                                <Typography variant='h4'>{stockorderproductId === -1 ? 'Add' : 'Edit'} Product of Stock Order </Typography>
                                <Divider />
                            </Grid>
                            <Grid height='35px' ></Grid>
                            {dataLoaded ?
                                <Grid container display="flex" spacing={2} direction="row" justifyContent="space-between" alignItems="center">

                                    <Grid item lg={4} xs={12} sx={{ display: 'none' }}>
                                        <TextField size="Normal"
                                            labelId="demo-simple-select-autowidth-label"
                                            id="demo-simple-select-autowidth"
                                            label={formValues.stitchingworkerid.label}
                                            name={formValues.stitchingworkerid.name}
                                            value={formValues.stitchingworkerid.value}
                                            onChange={handleDynamicSelectedValueForstitchingworkerid}

                                            error={formValues.stitchingworkerid.error}
                                            helpertext={formValues.stitchingworkerid.error && formValues.stitchingworkerid.errorMessage}
                                        >

                                        </TextField>

                                    </Grid>




                                    <Grid item lg={4} xs={12} sx={{ display: 'none' }}>
                                        <TextField size="Normal"
                                            placeholder={formValues.stockorderid.placeholder}
                                            required={formValues.stockorderid.required}
                                            label={formValues.stockorderid.label}
                                            name={formValues.stockorderid.name}
                                            value={formValues.stockorderid.value}
                                            onChange={handleTextChange}
                                            error={formValues.stockorderid.error}
                                            helperText={formValues.stockorderid.error && formValues.stockorderid.errorMessage}
                                            sx={{ width: '100%' }}
                                        />
                                    </Grid>
                                    <Grid item lg={4} xs={12} sx={{ display: 'none' }}>
                                        <TextField size="Normal"
                                            placeholder={formValues.title.placeholder}
                                            required={formValues.title.required}
                                            label={formValues.title.label}
                                            name={formValues.title.name}
                                            value={formValues.title.value}
                                            onChange={handleTextChange}
                                            error={formValues.title.error}
                                            helperText={formValues.title.error && formValues.title.errorMessage}
                                            sx={{ width: '100%' }}
                                        />
                                    </Grid>

                                    <Grid item lg={3} xs={12}>
                                        <FormControl sx={{ width: '100%' }} size="Normal">
                                            <InputLabel id="demo-simple-select-autowidth-label">Select A Product</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-autowidth-label"
                                                id="demo-simple-select-autowidth"
                                                label="Product"
                                                name={formValues.productid.name}
                                                value={formValues.productid.value}
                                                onChange={handleDynamicSelectedValueForproductid}

                                                error={formValues.productid.error}
                                                helpertext={formValues.productid.error && formValues.productid.errorMessage}
                                            >
                                                <MenuItem key={0} value="0">Select Item</MenuItem>
                                                {
                                                    productListByWorker && productListByWorker.map((item, i) => <MenuItem key={i} value={item.id}>{item.title}</MenuItem>)
                                                }
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item lg={2} xs={12}>
                                        <TextField
                                            size="Normal"
                                            placeholder={formValues.qty.placeholder}
                                            required={formValues.qty.required}
                                            label={formValues.qty.label}
                                            name={formValues.qty.name}
                                            value={formValues.qty.value}
                                            onChange={e => {
                                                // Allow only numbers
                                                const value = e.target.value.replace(/[^0-9]/g, '');
                                                handleTextChange({ target: { name: formValues.qty.name, value } });
                                            }}
                                            error={formValues.qty.error}
                                            helperText={formValues.qty.error && formValues.qty.errorMessage}
                                            sx={{ width: '100%' }}
                                            inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                                        />
                                    </Grid>
                                    {supplierTypeId === 0 && <>
                                    <Grid item lg={2} xs={6}>
                                        <TextField size="Normal"
                                            placeholder={formValues.stitchingrate.placeholder}
                                            required={formValues.stitchingrate.required}
                                            label={formValues.stitchingrate.label}
                                            name={formValues.stitchingrate.name}
                                            value={formValues.stitchingrate.value}
                                            onChange={handleDoubleChange}
                                            error={formValues.stitchingrate.error}
                                            helperText={formValues.stitchingrate.error && formValues.stitchingrate.errorMessage}
                                            sx={{ width: '100%' }}
                                        />
                                    </Grid>
                                    <Grid item lg={2} xs={6} >
                                        <Box sx={{ backgroundColor: 'secondary.100', borderRadius: 2 }}>
                                            <FieldView2 label="Wages" value={formValues.stitchingrate.value * formValues.qty.value} />
                                        </Box>
                                    </Grid>
                                    <Grid item lg={3} xs={12}>
                                        <TextField size="Normal"
                                            placeholder={formValues.stitchingworkername.placeholder}
                                            required={formValues.stitchingworkername.required}
                                            label={formValues.stitchingworkername.label}
                                            name={formValues.stitchingworkername.name}
                                            value={formValues.stitchingworkername.value}
                                            onChange={handleTextChange}
                                            error={formValues.stitchingworkername.error}
                                            helperText={formValues.stitchingworkername.error && formValues.stitchingworkername.errorMessage}
                                            sx={{ width: '100%' }}
                                            disabled
                                        />
                                    </Grid>
                                    
                                    </>}
                                    <Grid item lg={4} xs={12} sx={{ display: 'none' }}>
                                        <TextField size="Normal"
                                            placeholder={formValues.productname.placeholder}
                                            required={formValues.productname.required}
                                            label={formValues.productname.label}
                                            name={formValues.productname.name}
                                            value={formValues.productname.value}
                                            onChange={handleTextChange}
                                            error={formValues.productname.error}
                                            helperText={formValues.productname.error && formValues.productname.errorMessage}
                                            sx={{ width: '100%' }}
                                        />
                                    </Grid>
                                    <Grid item lg={3} xs={12}>
                                        <TextField size="Normal"
                                            placeholder={formValues.matter.placeholder}
                                            required={formValues.matter.required}
                                            label={formValues.matter.label}
                                            name={formValues.matter.name}
                                            value={formValues.matter.value}
                                            onChange={handleTextChange}
                                            error={formValues.matter.error}
                                            helperText={formValues.matter.error && formValues.matter.errorMessage}
                                            sx={{ width: '100%' }}
                                        />
                                    </Grid>





                                    <Grid item lg={2} xs={6}>
                                        <FormControl sx={{ width: '100%' }} size="Normal">
                                            <InputLabel id="demo-simple-select-autowidth-label">Priority</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-autowidth-label"
                                                id="demo-simple-select-autowidth"
                                                label="Priority"
                                                name={formValues.deliverypriorityid.name}
                                                value={formValues.deliverypriorityid.value ? formValues.deliverypriorityid.value : 2}
                                                onChange={handleDynamicSelectedValueFordeliverypriorityid}

                                                error={formValues.deliverypriorityid.error}
                                                helpertext={formValues.deliverypriorityid.error && formValues.deliverypriorityid.errorMessage}
                                            >
                                                <MenuItem key={0} value="0">Select Item</MenuItem>
                                                {
                                                    mfdeliverypriorityList && mfdeliverypriorityList.map((item, i) => <MenuItem key={i} value={item.id}>{item.title}</MenuItem>)
                                                }
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item lg={2} xs={12} sx={{ display: 'none' }}>
                                        <TextField size="Normal"
                                            placeholder={formValues.deliverypriorityname.placeholder}
                                            required={formValues.deliverypriorityname.required}
                                            label={formValues.deliverypriorityname.label}
                                            name={formValues.deliverypriorityname.name}
                                            value={formValues.deliverypriorityname.value}
                                            onChange={handleTextChange}
                                            error={formValues.deliverypriorityname.error}
                                            helperText={formValues.deliverypriorityname.error && formValues.deliverypriorityname.errorMessage}
                                            sx={{ width: '100%' }}
                                        />
                                    </Grid>
                                    <Grid item lg={2} xs={6}>
                                        <MyDate
                                            label={formValues.expecteddelivery.label}
                                            fieldName={formValues.expecteddelivery.name}
                                            defaultValue={formValues.expecteddelivery.value}
                                            errStr={formValues.expecteddelivery.errorMessage}
                                            setDate={setDate}
                                        />
                                    </Grid>
                                    <Grid item lg={2} xs={6}>
                                        <RadioForBoolean
                                            label={formValues.withprinting.label}
                                            fieldName={formValues.withprinting.name}
                                            defaultValue={getRadioValue(formValues.withprinting.value)}
                                            handleChange={handleRadioChange}
                                        />
                                    </Grid>

                                    <Grid item lg={2} xs={6} sx={{ display: formValues.withprinting.value ? 'inline' : 'none' }}>
                                        <RadioForPrintingType
                                            label={formValues.printingtype.label}
                                            fieldName={formValues.printingtype.name}
                                            defaultValue={getRadioValue(formValues.printingtype.value)}
                                            handleChange={handleRadioChange}
                                        />
                                    </Grid>
                                    <Grid item lg={2} xs={6}>
                                        <RadioForStitchingType
                                            label={formValues.stitchingtype.label}
                                            fieldName={formValues.stitchingtype.name}
                                            defaultValue={getRadioValue(formValues.stitchingtype.value)}
                                            handleChange={handleRadioChange}
                                        />
                                    </Grid>

                                    <Grid item lg={4} xs={12} sx={{ display: 'none' }}>
                                        <TextField size="Normal"
                                            placeholder={formValues.businessid.placeholder}
                                            required={formValues.businessid.required}
                                            label={formValues.businessid.label}
                                            name={formValues.businessid.name}
                                            value={formValues.businessid.value}
                                            onChange={handleTextChange}
                                            error={formValues.businessid.error}
                                            helpertext={formValues.businessid.error && formValues.businessid.errorMessage}
                                            sx={{ width: '100%', }}
                                        />
                                    </Grid>
                                    <Grid item lg={12} xs={12}>
                                        <TextField
                                            size="Normal"
                                            placeholder={formValues.remarks.placeholder}
                                            required={formValues.remarks.required}
                                            label={formValues.remarks.label}
                                            name={formValues.remarks.name}
                                            value={formValues.remarks.value}
                                            onChange={handleTextChange}
                                            error={formValues.remarks.error}
                                            helperText={formValues.remarks.error && formValues.remarks.errorMessage}
                                            sx={{ width: '100%' }}
                                            multiline
                                            minRows={2}
                                        />
                                    </Grid>
                                </Grid>
                                : <></>}
                        </Grid>
                    </Grid>
                </Box>
                <Grid padding={1}>
                    <Divider />
                </Grid>
                <Grid container direction="row" justifyContent="flex-end"  >
                    {apiInProgress ? <CircularProgress /> :
                        <>
                            <Button variant="outlined" type="submit" >{stockorderproductId === -1 ? 'Add' : 'Save'}</Button>&nbsp;&nbsp;&nbsp;
                            <Button variant="outlined" onClick={() => { dispatch(setShowEditForStockorderproduct(false)); }}>Close</Button>
                        </>
                    }
                </Grid>
            </Grid>
        </form>
    );
};